export const DEVELOPMENT_DASHBOARD_PATH = '/development-dashboard';
export const COMMUNITY_ADMIN_PATH = '/community-admin';

// The community admin tools. The backend allows them for a community admin
// only, a dev admin permission does not grant access.
export const communityAdminTools = [
  {
    key: 'purchases-overview',
    title: 'Purchases overview',
    description:
      'Users that bought something in the last 5 days, with their survey activity of the last 5 months.',
    path: '/purchases-overview'
  },
  {
    key: 'user-cost',
    title: 'User cost',
    description:
      'Tokens earned from community and commercial surveys, and what they pay for.',
    path: '/user-cost'
  }
];

export const toolsWithBasePath = (tools, basePath) =>
  tools.map(tool => ({ ...tool, to: `${basePath}${tool.path}` }));
